import { WaterfallDropDownBase } from "./waterfallDropDownBase"

export class WaterfallDropDown extends WaterfallDropDownBase {
    constructor(public toggleElement: HTMLElement, protected readonly alignRight = true) {
        super({}, toggleElement, alignRight)
    }
}
